import React, { useEffect, useState } from 'react';
import { homeAPI } from '../../../Api/api';
import './HomeFigure.css';
import { useAppLanguage } from '../../../Hooks/useAppLanguage';
import Loaders from '../../../Component/UI/Loaders/Loaders';
import { bannerPlaceholder } from '../../../data/bannerPlaceholder';

function HomeFigure() {
    const { selectedLanguage } = useAppLanguage();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await homeAPI.getBanner();
                const data = response.data || [];
                if (data.length === 0) {
                    setItems(bannerPlaceholder);
                } else {
                    setItems(data);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                setItems(bannerPlaceholder);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return (
            <main>
                <section className='section'>
                    <Loaders variant="banner" />
                </section>
            </main>
        );
    }

    return (
        <main>
            <section className='section'>
                <div className='home-figure-container container grid'>
                <h1 className="figure-title container">
                            {items[0]?.description?.[selectedLanguage] || '…no description…'}
                        </h1>

                    {items[0] && (
                        <article className="home-figure-card first-image">
                            <img
                                src={items[0]?.imageUrl[0]}
                                className="home-figure-img"
                                alt='Banner'
                            />
                        </article>
                    )}

                    {items[0] && (
                        <article className="home-figure-card second-image">
                            <img
                                src={items[0]?.imageUrl[1]}
                                alt='Banner'
                                className="home-figure-img"
                            />
                        </article>
                    )}
                </div>
            </section>
        </main>
    );
}

export default HomeFigure;
